///
/// EarthBrowser
///
/// Created by Matt Giger on 10/29/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Request headers that identify the native app to api-server
/// (api-server/src/utils/native-client.ts, utils/Device.ts): the platform
/// (gates Turnstile) and a human-readable device description for the
/// Devices table. Device info is read once at startup; until then only the
/// platform header is sent.
///

import { Device } from '@capacitor/device'
import { isNativeApp, nativePlatform } from './platform'

let deviceHeaders: Record<string, string> = {}

/** Resolve device model / OS once; safe to call repeatedly */
export async function loadNativeDeviceInfo(): Promise<void> {
	if (!isNativeApp()) return
	try {
		const info = await Device.getInfo()
		const headers: Record<string, string> = {}
		if (info.model) headers['X-EB-Device-Model'] = info.model
		if (info.operatingSystem) headers['X-EB-Device-OS'] = info.operatingSystem === 'ios' ? 'iOS' : capitalize(info.operatingSystem)
		if (info.osVersion) headers['X-EB-Device-OS-Version'] = info.osVersion
		deviceHeaders = headers
	} catch {
		// Plugin missing in a partially synced build; platform header still goes out
	}
}

/** Headers to attach to every api-server request from the native app ({} on the web) */
export function nativeRequestHeaders(): Record<string, string> {
	const platform = nativePlatform()
	if (!platform) return {}
	return { 'X-EB-Client': platform, ...deviceHeaders }
}

function capitalize(value: string): string {
	return value.charAt(0).toUpperCase() + value.slice(1)
}
